import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba 8 meses con dolor de rodilla que volvía siempre al kilómetro 18. Con el Semáforo del Dolor del Tomo 1 entendí que estaba ignorando señales claras. En 3 semanas corrí sin dolor por primera vez en casi un año.',
    author: 'María L.',
    location: 'Corredora amateur · Buenos Aires',
    initial: 'M'
  }, {
    quote: 'Siempre salía a lo que salía. Con el Mapa de Ritmos entendí que el 80% de mis salidas estaban en zona gris: demasiado duro para recuperarme y demasiado suave para mejorar. En 6 semanas bajé 4 minutos mi marca en 10K.',
    author: 'Roberto S.',
    location: 'Corredor de ruta · Mendoza',
    initial: 'R'
  }, {
    quote: 'Nunca pensé que iba a poder entrenar bien con solo 3 días por semana. El Tomo 2 me cambió la cabeza. Entreno menos horas pero con mucho más resultado.',
    author: 'Diego F.',
    location: 'Corredor amateur · Rosario',
    initial: 'D'
  }, {
    quote: 'Los geles caseros del Tomo 4 son una revolución. Membrillo, agua y sal. Ahorro una fortuna por salida y rindo igual o mejor que antes.',
    author: 'Lucía M.',
    location: 'Corredora de ruta y trail · Córdoba',
    initial: 'L'
  }, {
    quote: 'La Checklist Pre-Carrera del Bono 2 parece una pavada pero me salvó. La noche anterior al 21K revisé todo y me di cuenta de que iba a estrenar zapatillas. Saqué las viejas y corrí mi mejor marca.',
    author: 'Andrés P.',
    location: 'Corredor trail · Salta',
    initial: 'A'
  }, {
    quote: 'Hice la rutina de fuerza del Tomo 5 dos veces por semana durante 8 semanas. El dolor de banda iliotibial que tenía hace un año desapareció. Nunca pensé que 15 minutos podían hacer eso.',
    author: 'Facundo R.',
    location: 'Corredor de ruta · Santa Fe',
    initial: 'F'
  }];
  const Stars = () => <div className="flex gap-1 md:gap-1.5 text-[#22c55e] mb-3 md:mb-6" data-id="element-381">
      {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" className="drop-shadow-[0_0_5px_rgba(34,197,94,0.3)] w-4 h-4 md:w-5 md:h-5" data-id="element-382" />)}
    </div>;
  return <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto bg-[#f8fafc]" data-id="element-383">
      <FadeIn data-id="element-384">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-2 md:gap-4 px-2" data-id="element-385">
          <span className="text-[#ef4444] drop-shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-386">
            ❤️
          </span>{' '}
          LO QUE DICEN LOS QUE YA LO TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-387">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-388">
            <motion.div whileHover={{
          y: -5
        }} className="bg-white border border-[#e2e8f0] hover:border-[#22c55e]/50 rounded-2xl md:rounded-3xl p-5 md:p-8 h-full relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-389">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-[#f1f5f9] w-16 h-16 md:w-24 md:h-24 rotate-180 -z-0" data-id="element-390" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-391">
                <Stars data-id="element-392" />
                <p className="text-base md:text-xl text-[#0f172a] mb-4 md:mb-8 italic leading-relaxed font-medium flex-grow" data-id="element-393">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-[#e2e8f0]" data-id="element-394">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#22c55e] to-[#4ade80] rounded-full flex items-center justify-center text-[#020617] font-black text-base md:text-xl shadow-[0_5px_15px_rgba(34,197,94,0.3)]" data-id="element-395">
                    {t.initial}
                  </div>
                  <div data-id="element-396">
                    <p className="font-black text-[#0f172a] text-base md:text-lg" data-id="element-397">
                      {t.author}
                    </p>
                    <p className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-398">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}